module.exports = __webpack_public_path__ + "img/basketball.2a349491.jpg";